import type { ChangeEvent } from 'react';
import { handleKeyPress, handlePaste } from './utils';

interface MonthInputProps {
  testId?: string;
  value?: string; // A string of mm
  disabled?: boolean;
  label?: string;
  anchorId?: string;
  onChange?(value: string): void;
}

export default function MonthInput({
  testId,
  value = '',
  disabled = false,
  label,
  anchorId,
  onChange,
}: MonthInputProps) {
  const MONTH_LENGTH = 2;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (
      onChange &&
      event.target.value.length <= MONTH_LENGTH &&
      (event.target.value === '' || event.target.valueAsNumber <= 12)
    ) {
      onChange(`${event.target.value}`);
    }
  };

  const handleBlur = () => {
    if (value.length > 0 && value.length < MONTH_LENGTH) {
      const paddedMonth = value.padStart(MONTH_LENGTH, '0');
      if (onChange) {
        onChange(`${paddedMonth}`);
      }
    }
  };

  return (
    <div className="govuk-date-input__item">
      <div className="govuk-form-group">
        <label className="govuk-label govuk-date-input__label" htmlFor={anchorId}>
          {label}
        </label>
        <input
          className="govuk-input govuk-date-input__input govuk-input--width-2"
          id={anchorId}
          data-testid={testId}
          type="number"
          size={MONTH_LENGTH}
          value={value}
          onChange={handleChange}
          onBlur={() => handleBlur()}
          disabled={disabled ?? false}
          onKeyDown={(e) => handleKeyPress(e)}
          onPaste={(e) => handlePaste(e)}
          onFocus={(e) =>
            e.target.addEventListener('wheel', (e) => e.preventDefault(), { passive: false })
          }
        />
      </div>
    </div>
  );
}
